import React, { useCallback, useEffect, useState } from 'react';
import { OverlayTrigger, Spinner, Tooltip } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { MdOutlineContentCopy, MdStar } from 'react-icons/md';
import { toast } from 'react-toastify';
import { useLocalStorage } from 'react-use';
import { UserType } from '../../../context/userContext/props';
import { useNotification } from '../../../hooks/useNotifications';
import { ISubscription } from '../../models/ISubscriptionDetails';
import { requestMediaLink } from '../../services/media.service';
import copyToClipboard from '../../utils/copyToClipboard/copyToClipboard';
import { DefaultButton } from './styles';
import UpgradePlan from './upgrade-plan';
import { subscription } from '../../services/login/login.service';
import { useRecoilState } from 'recoil';
import { subscriptionState } from '../../../hooks/atoms/subscriptions';


interface ICopyComponent {
	copyText: string;
	color?: string;
	labelText?: string;
	children?: any;
	onCopy: (copiedText: string) => void;
	customClassName?: string;
	userZombie?: UserType;
	ownsMaterial: boolean;
}

const testUser: UserType = {
	id: 1,
	is_superuser: true,
	token: "teste",
	name: "teste",
	email: "teste",
	company: "teste",
	is_active: true,
	job: "teste",
	is_signature: true,
	is_staff: true,
	phone: "5893582394",
	username: "teste",
	picture: "gregewr",
	is_whatsapp: false,
	is_token_config: false,
	permissions: { menus: [], subMenus: [] },
	profile_status: "teste",
	remember: true,
};

export const CopyComponent: React.FC<ICopyComponent> = ({
	copyText,
	color = "#606060",
	onCopy,
	labelText = "",
	children,
	customClassName,
	userZombie = testUser,
	ownsMaterial,
}) => {
	const { t: translation } = useTranslation();
	const [user, setUser] = useState<UserType>(userZombie);
	const [isLoading, setIsLoading] = useState<boolean>(false);

	// const [subscriptionDetails, setSubscriptionDetails] = useLocalStorage<ISubscription>('subscription')
	const [subscriptionDetails, setSubscriptionDetails] = useRecoilState(subscriptionState)

	const { addNotification} = useNotification()

	useEffect(() => {
		let usuario = localStorage.getItem("user-store");
		if (usuario) {
			let auth = JSON.parse(usuario);
			setUser(auth);
		}
	}, []);

    const handleCopy = useCallback(() => {
        onCopy(copyText)
        setIsLoading(true)
        if (subscriptionDetails) {
            if (subscriptionDetails.has_reached_limit && !ownsMaterial) {
                toast.warning(<UpgradePlan onUpgrade={() => { window.open("/plans", "_blank"); }} />, {
                    autoClose: false,
                    icon: false,
                    pauseOnFocusLoss: false,
                    style: { width: 375, right: 50}
                    
                })
                setIsLoading(false)
                return;
            }
        }
        requestMediaLink(copyText).then((res) => {
            copyToClipboard(res.link)

            toast.success(translation('components.card-object.copied'), {
                hideProgressBar: true,
                closeButton: false,
                autoClose: 1000,
            })
            setIsLoading(false)
            addNotification();
            handleGetSubscription();
        }).catch(() => {
            toast.warning(<UpgradePlan onUpgrade={() => { window.open("/plans", "_blank"); }} />, {
                autoClose: false,
                icon: false,
                pauseOnFocusLoss: false,
            })
            setIsLoading(false)
        })
    }, [copyText, translation, onCopy])

    const handleGetSubscription = () => {
		subscription().then((res: ISubscription) => {
			setSubscriptionDetails(res)
		})
	}

    return (
        <>
            {!!user && (user.is_signature || user.is_superuser) && (
                <>
                    {isLoading && (
                        <Spinner animation="border" variant="primary" style={{ width: 24, height: 24 }} />
                    )}

                    {!isLoading && (
                        <OverlayTrigger
                            placement={'top'}
                            overlay={<Tooltip id={`tooltip-materials`}>{translation('components.card-object.copy')}</Tooltip>
                            }
                        >
                            <DefaultButton style={{ position: 'relative' }} className={customClassName} type='button' data-testid="copybtn" onClick={handleCopy} >
                                {subscriptionDetails && (
                                    <>
                                        {subscriptionDetails.has_reached_limit && !ownsMaterial && (
                                            <MdStar size={13} color='#F39035' style={{ position: 'absolute', right: 5 + "%" }} />
                                        )}
                                    </>

                                )}

                                <MdOutlineContentCopy size={24} color={color} /> {labelText}
                            </DefaultButton>
                        </OverlayTrigger>
                    )}


                </>
            )}
        </>

    )
} 
